var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFootball(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.071 4.929C17.17 3.03 14.66 1.98 12 1.98 9.33 1.98 6.82 3.03 4.92 4.91c-3.9 3.89-3.9 10.24 0 14.14 1.89 1.89 4.406 2.93 7.07 2.93 2.66 0 5.17-1.05 7.07-2.94 3.89-3.9 3.89-10.25-.01-14.15Zm-6.89-.93h-.359c.06-.01.11-.01.18-.01 .06 0 .11 0 .17 0Zm6.06 13h-2.25l-1.26 2.51c-.87.31-1.8.49-2.75.49 -.952 0-1.88-.18-2.75-.5l-1.26-2.51h-2.24c-.85-1.06-1.39-2.269-1.63-3.532l1.85-2.48L4.73 8.54c.38-.81.89-1.56 1.55-2.224 .91-.92 2.02-1.59 3.22-1.97l2.43 1.62 2.43-1.625c1.19.38 2.3 1.04 3.22 1.968 .66.66 1.17 1.41 1.55 2.221l-1.22 2.436 1.85 2.47c-.24 1.25-.78 2.47-1.62 3.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 11l1.5 4h4l1.5-4L12 8.5Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootball);
export default __webpack_public_path__ + "static/media/football.c9afde35.svg";
export { ForwardRef as ReactComponent };